import NodeCache from 'node-cache';

// Configuration
const CACHE_TTL_SECONDS = 600;
const CACHE_CHECK_PERIOD_SECONDS = 60;

// Initialize cache
const contentfulCache = new NodeCache({
  stdTTL: CACHE_TTL_SECONDS,
  checkperiod: CACHE_CHECK_PERIOD_SECONDS,
  useClones: false,
});

/**
 * Get data from cache or fetch if not cached
 *
 * @param {string} cacheKey - Unique identifier for this cache entry
 * @param {Function} fetchFunction - Async function that fetches data if cache misses
 * @returns {Promise<any>} The cached or freshly fetched data
 */
export const getCachedOrFetch = async (cacheKey, fetchFunction) => {
  const cached = contentfulCache.get(cacheKey);

  if (cached !== undefined) {
    return cached;
  }

  const data = await fetchFunction();

  // Store in cache
  contentfulCache.set(cacheKey, data);

  return data;
};

/**
 * Clear all cached Contentful data
 * Use this when content is updated in Contentful
 */
export const clearContentfulCache = () => {
  const keysCleared = contentfulCache.keys().length;
  contentfulCache.flushAll();

  return keysCleared;
};

/**
 * Clear specific cache entry by key
 *
 * @param {string} cacheKey - The key to clear
 * @returns {number} Number of entries deleted (0 or 1)
 */
export const clearCacheKey = cacheKey => {
  const deleted = contentfulCache.del(cacheKey);

  return deleted;
};

export default {
  getCachedOrFetch,
  clearContentfulCache,
  clearCacheKey,
};
